<template><div><h1>VUX V2.1.0Rc.47 released</h1>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul></ul>
<h2><a href="/en/components/qrcode.html">Qrcode</a></h2>
<ul></ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul></ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.47 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.47-70.vue?1b1ecc4a